import React from "react";
import PropTypes from "prop-types";
import i18next from "./locales/i18next";
import { I18nextProvider } from "react-i18next";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { Header } from "@learningblocks/storybook-components/lib/Header";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import "./style.scss";
import { Footer } from "./footer/footer";

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export function AnimationSequence(props) {
  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  const finishStep = () => {
    props.onStepFinished();
    props.toggleModal();
  };

  return (
    <>
      <I18nextProvider i18n={i18n}>
        <Modal
          className="as_modal"
          isOpen={props.isOpen}
          close={props.toggleModal}
          size={"sim"}
          closeButton={true}
          notebookExpanded={props.notebookExpanded}
          lang={props.lang}
        >
          <Header className={"header"} label={props.title} size="lg" />

          <div className="modal-body">
            <div className="modal-inner">
              <Player autoplay controls src={props.animation}>
                <Controls visible={true} buttons={["play", "stop", "repeat"]} />
              </Player>
            </div>
          </div>
          <Footer
            modalData={props.modalData}
            finishStep={finishStep}
            lang={props.lang}
          />
        </Modal>
      </I18nextProvider>
    </>
  );
}

AnimationSequence.propTypes = {
  /**
   * spcifies animation to display
   */
  animation: PropTypes.any,

  title: PropTypes.string,
  /**
   * specified callback function when step finishes
   */
  onStepFinished: PropTypes.func,

  toggleModal: PropTypes.func,

  isOpen: PropTypes.bool,

  modalData: PropTypes.any,

  notebookExpanded: PropTypes.bool,

  lang: PropTypes.oneOf([
    "en",
    "ar",
    "ja",
    "nl",
    "de",
    "es",
    "fr",
    "it",
    "ko",
    "pt",
    "tr",
    "zh",
    "zu",
  ]),
};

AnimationSequence.defaultProps = {
  modalData: {},
};
